import { apiClient } from '@app/lib'
import { type SugarEnrollmentCreate, type SugarEnrollmentCreateResponse } from '@app/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useCreateEnrollment = () => {
  const queryClient = useQueryClient()
  const { isPending, mutateAsync } = useMutation({
    mutationFn: async (input: SugarEnrollmentCreate) => {
      const { data } = await apiClient.put<SugarEnrollmentCreateResponse>('/api/enrollments', input)

      return data
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['enrollments']
      })
  })

  return {
    isCreatingEnrollment: isPending,
    createEnrollment: mutateAsync
  }
}
